<template>
  <b-modal
    ref="modal"
    v-bind="$attrs"
    :size="size"
    :class="modalClass"
    :centered="centered"
    :body-class="bodyClass"
    :modal-class="customClass"
    :title-html="titleHtml"
    :hide-footer="hideFooter"
    :header-class="headerClass"
    :title-class="titleClass"
    :hide-header-close="hideHeaderClose"
    :hide-header="hideHeader"
    :static="statics"
    no-close-on-esc
    no-close-on-backdrop
    @close="hide()"
  >
    <div v-if="bodyMessage">
      <p>{{ bodyMessage }}</p>
    </div>

    <div
      class="d-flex justify-content-center align-items-center h-100 w-100"
      :class="{
        'flex-column': !buttonTop,
        'flex-column-reverse': buttonTop,
      }"
    >
      <component
        v-if="component"
        :is="computedComponent"
        :parameters="parameters"
        ref="component"
        class="w-100 h-100"
        @onClick="$emit('onClick', $event)"
      />
      
      <slot v-else name="custom-component"></slot>

      <div
        class="row reverse justify-content-end w-100"
        :class="{
          'mb-3': buttonTop,
          [`${btnContainerClass}`]: btnContainerClass
        }"
        v-if="computedButtons"
      >
        <Button
          v-if="!!noText"
          :loading="loading"
          :label="noText"
          :class="noBtnClass"
          class="btn px-4 py-1"
          @click="hide()" 
        />
        <Button
          v-if="!!yesText"
          :loading="loading"
          :label="yesText"
          :class="yesBtnClass"
          :disabled="buttonDisable"
          class="btn px-4 py-2 ml-1"
          @click="onClickYes()"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import DialogMixins from '@mixins/dialog'
import Button from '@components/buttons'

export default {
  components: {
    Button,
  },
  mixins: [ DialogMixins ],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    titleClass: String,
    bodyClass: String,
    customClass: String,
    headerClass: String,
    titleHtml: String,
    bodyMessage: String,
    yesText: String,
    noText: String,
    modalClass: String,
    btnContainerClass: String,
    size: {
      type: String,
      default: 'sm'
    },
    noBtnClass: {
      type: String,
      default: "btn-secondary"
    },
    yesBtnClass: {
      type: String,
      default: "btn-primary"
    },
    buttonTop: {
      type: Boolean,
      default: false
    },
    buttonDisable: {
      type: Boolean,
      default: false
    },
    statics: {
      type: Boolean,
      default: false
    },
    submitted: {
      type: Boolean,
      default: false
    },
    emitYesFunc: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    },
    hideHeaderClose: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: true
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    is_reset_model: {
      type: Boolean,
      default: false
    },
    autoload: {
      type: Boolean,
      default: false
    },
    component: [ Object, Function ],
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    computedButtons () {
      return !!this.yesText || !!this.noText
    },
    computedComponent () {
      return this.component
    }
  },
  methods: {
    show() {
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
      
      if (this.component) {
        if (this.is_reset_model) {
          this.resetModel(this.$refs.component)
        }
        if (this.autoload) {
          this.reload(this.$refs.component)
        }
      }
    },
    onClickYes() {
      if (this.component) {
        this.$emit('onYes', this.$refs.component)
      }
      else this.$emit('onYes')
    }
  }
}

</script>